module.exports = __webpack_public_path__ + "img/30_46.a36c3f72.png";